/**
 * Validator Utilities
 *
 * If you add a new assertion to this list, make sure to add a unit test for it.
 */
import _ from 'lodash';

const alphaNumericWithoutSpecialCharactersRegex = /^[a-zA-Z0-9!& '\-.,]+$/i;

export const isAlphaNumericWithoutSpecialCharacters = (str) =>
  alphaNumericWithoutSpecialCharactersRegex.test(str);

export const isValidUsZip = (zipCode) => /^\d{5}(-\d{4})?$/.test(zipCode);

export const isEmpty = (value) => _.isEmpty(value);
